import Box from "glesys-controlpanel/components/box";
import InfoPopup from "glesys-controlpanel/components/info-popup";
import StatusIndicator from "glesys-controlpanel/components/status-indicator";
import { hash } from "@ember/helper";
import { t } from "ember-intl";

<template>
  <Box data-test-database-details-backup ...attributes>
    <span class="text-black text-sm flex items-center gap-2">
      {{#if @database.hasPitr}}
        {{t "databases.details.pitr.title"}}
      {{else}}
        {{t "label.backups"}}
        <InfoPopup>
          {{t "databases.details.backup-info"}}
        </InfoPopup>
      {{/if}}
    </span>
    {{#if @database.hasPitr}}
      <StatusIndicator
        class="text-2xl text-black mt-2"
        data-test-database-pitr-status={{@database.pitrStatus}}
        @status={{@database.pitrStatusIndicator}}
        @showLabel={{true}}
        @size="large"
      />
    {{else}}
      <StatusIndicator
        class="text-2xl text-black mt-2"
        @status={{hash state="online" labelKey="label.enabled"}}
        @showLabel={{true}}
        @size="large"
      />
    {{/if}}
  </Box>
</template>
